import { ScanRackComponent } from './scan-rack/scan-rack.component';
import { BatchComponent } from './batch/batch.component';
import { AuthGuardService } from './../../auth/auth-guard.service';
import { EditComponent } from './edit/edit.component';
import { CreateComponent } from './create/create.component';
import { DetailComponent } from './detail/detail.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListComponent } from './list/list.component';
import { EditComponent as ScanRackEditComponent } from './scan-rack/edit/edit.component';
import { StorageComponent } from './storage/storage.component';

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ListComponent
      },
      {
        path: 'detail/:id',
        component: DetailComponent
      },
      {
        path: 'storage',
        component: StorageComponent
      },
      {
        path: 'batch',
        component: BatchComponent
      },
      {
        path: 'edit/:id',
        component: EditComponent
      },
      {
        path: 'scan-rack',
        component: ScanRackComponent,
        loadChildren: './scan-rack/scan-rack.module#ScanRackModule'
      },
      {
        path: 'products',
        component: ListComponent
      },
      {
        path: 'event',
        loadChildren: './event/event.module#EventModule'
      }
    ],
    canActivate: [AuthGuardService],
    runGuardsAndResolvers: 'always'
  }
];

@NgModule({
  imports: [RouterModule.forChild(appRoutes)],
  exports: [RouterModule]
})
export class InventoryRoutingModule {}
